/* --------------------------------------------------------------------------------------
   main.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const mainComponent = {
  template: require("./main.html"),
  controller: "mainCtrl",
  controllerAs: "vm",
};

export class mainCtrl {
  /*@ngInject*/
  constructor(
    commonService,
    browserService,
    deviceInfoService,
    ssoClientService,
    sessionDataService,
    persistService,
    $state,
    $translate
  ) {
    this.commonService = commonService;
    this.deviceInfoService = deviceInfoService;
    this.ssoClientService = ssoClientService;
    this.sessionDataService = sessionDataService;
    this.persistService = persistService;
    this.browserService = browserService;
    this.$state = $state;
    this.$translate = $translate;
  }

  async $onInit() {
    this.loading = true;
    this.buildLogoutConfirmButtons();
    const deviceInfo = this.deviceInfoService.get();
    this.lang = deviceInfo.localizationLanguage;
    try {
      this.sessionDataService.user = await this.ssoClientService.getUser();
      this.sessionDataService.username =
        this.sessionDataService.user.Name.split(" ")[0];
      this.sessionDataService.lastOp = "main";
    } catch (e) {
      this.ssoClientService.logout();
      this.$state.go("forcelogin");
    } finally {
      this.loading = false;
      this.commonService.updateView();
    }
  }

  errorClosed() {
    this.error = false;
    this.commonService.updateView();
  }

  privacyStatementClosed() {
    this.privacyStatement = false;
    this.commonService.updateView();
  }

  openSettings() {
    this.showSettings = true;
  }

  async buildLogoutConfirmButtons() {
    this.confirmLogoutButtons = [
      {
        alertIcon: "glyphicon-close",
        text: await this.$translate("CANCEL"),
        click: () => this.cancelLogout(),
      },
      {
        alertIcon: "glyphicon-exit",
        text: await this.$translate("LOG_OUT"),
        click: () => this.logout(),
      },
    ];
  }

  showConfirmLogout() {
    this.confirmLogout = true;
  }

  cancelLogout() {
    this.confirmLogout = false;
    this.commonService.updateView();
  }

  logout() {
    this.ssoClientService.logout();
    this.$state.go("login");
  }
}



// WEBPACK FOOTER //
// ./src/app/components/main.component.js